import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import Logo from '../assests/logo.jpeg'; // Replace with your logo path

const links = [
  "Home",
  "About Us",
  "Services",
  "Industries",
  "Resources",
  "Join Us",
  "Careers",
  "Contact Us",
  "Admin"
];

export default function Navigation() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const formatPath = (label) =>
    '/' + label.toLowerCase().replace(/ \/ /g, '-').replace(/ /g, '-');

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="fixed top-0 left-0 right-0 bg-black px-4 py-3 shadow-md z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2">
          <img src={Logo} alt="Logo" className="w-10 h-10 object-contain" />
          <span className="text-white font-semibold text-xl hidden sm:inline">Prisu Experts</span>
        </Link>

        {/* Hamburger Menu Button */}
        <button
  className="sm:hidden bg-black p-2 rounded flex flex-col justify-center items-center space-y-1"
  onClick={toggleMenu}
  aria-label="Toggle menu"
>
  <span className="block w-6 h-0.5 bg-white"></span>
  <span className="block w-6 h-0.5 bg-white"></span>
  <span className="block w-6 h-0.5 bg-white"></span>
</button>


        {/* Links - Desktop */}
        <div className="hidden sm:flex flex-wrap gap-3 justify-center">
          {links.map((label, index) => {
            const path = formatPath(label);
            const isActive = location.pathname === path;

            return (
              <Link
                key={index}
                to={path}
                className={`px-4 py-2 rounded-full transition font-medium text-sm whitespace-nowrap ${
                  isActive
                    ? 'bg-indigo-600 text-white shadow'
                    : 'bg-gray-900 text-white hover:bg-indigo-600'
                }`}
              >
                {label}
              </Link>
            );
          })}
        </div>
      </div>

      {/* Links - Mobile Dropdown */}
      {menuOpen && (
        <div className="sm:hidden mt-4 flex flex-col gap-2">
          {links.map((label, index) => {
            const path = formatPath(label);
            const isActive = location.pathname === path;

            return (
              <Link
                key={index}
                to={path}
                onClick={() => setMenuOpen(false)}
                className={`block w-full text-center px-4 py-2 rounded-full transition font-medium text-sm ${
                  isActive
                    ? 'bg-indigo-600 text-white shadow'
                    : 'bg-gray-900 text-white hover:bg-indigo-600'
                }`}
              >
                {label}
              </Link>
            );
          })}
        </div>
      )}
    </nav>
  );
}
